import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react'
import { createPortal } from 'react-dom'

const TalentToolbarContext = createContext(null)

export function TalentToolbarProvider({ children }) {
    const [slotEl, setSlotElState] = useState(null)

    const setSlotEl = useCallback((el) => {
        setSlotElState((prev) => (prev === el ? prev : el))
    }, [])

    const value = useMemo(
        () => ({
            slotEl,
            setSlotEl,
        }),
        [slotEl, setSlotEl]
    )

    return (
        <TalentToolbarContext.Provider value={value}>
            {children}
        </TalentToolbarContext.Provider>
    )
}

export function useTalentToolbarSlot() {
    return useContext(TalentToolbarContext)
}

/** Renders page controls into the Talent header toolbar slot. */
export function TalentToolbar({ children }) {
    const ctx = useTalentToolbarSlot()
    if (!ctx?.slotEl) return null
    return createPortal(children, ctx.slotEl)
}
